<template>
        <div class="modal fade filter-modal" :id="id" ref="modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                            <h4 class="">{{title !== '' ? lang(title): lang('filter_data')}}</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" data-backdrop="false" @click="cancel"></button>
                    </div>
                    <np-preloader v-if="loading" style="margin:0"></np-preloader>
                    <div class="modal-body">
                        <slot name="np_filter_modal" v-if="use_pop_slot"></slot>
                        <div class="row" v-else>
                            <div class="col-md-4 col-6" v-for="(datum) in Object.entries(display_data)">
                                <np-entry :label="lang(datum[0])" :model-value="datum[1]"></np-entry>
                            </div>
                        </div>
                    </div>
                    <div v-if="mode === 'view-only'" class="modal-footer">
                        <a class="btn btn-default"data-bs-dismiss="modal" data-backdrop="false"  @click="cancel">{{lang('close')}}</a>
                    </div>
                    <div v-else-if="mode === 'custom'">
                        <slot name="footer"></slot>
                    </div>
                    <div v-else class="modal-footer">
                        <a class="btn btn-danger" data-bs-dismiss="modal" data-backdrop="false"  @click="cancel">{{lang('cancel')}}</a>
                        <!--<a class="btn btn-default" @click="confirm" :disabled="submitting">{{lang('save')}} <i class="fa fa-spinner fa-spin" :class="{displayNone: !submitting}" ></i> </a>-->
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        name: "np-filter-pop-up-display",
        description: "This component is used to display filter row data in a Pop Up block",
        data: function () {
            return {
                loading: false
            }
        },
        props: {
            mode: {
                type: String,
                default: 'view-only'
            },
            id: {
                type: String,
                required: true
            },
            use_pop_slot: {
                type: Boolean,
                default: () => false,
            },
            display_data: {
                type: Object,
                required: true,
                note: 'Data that will be displayed in the Pop Up view'
            },
            title: {
                default: () => {
                    return ''
                }
            }
        },
        methods: {
            cancel: function () {
                //$('#' + this.id).modal('hide');
              let modalEl = document.querySelector('#' + this.id)
              let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
              modal.hide();
            },
            show: function () {
               // $('#' + this.id).modal('show');
                let modalEl = document.querySelector('#' + this.id)
                let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
                modal.show();
                $('.modal-backdrop').css('display', 'none');
            },
        }
    }
</script>
<style scoped>
    .filter-modal .modal-dialog {
        top: 100px;
        width: 80%;
        height: 60%;
    }
    .modal-body{
        overflow: hidden;
    }
</style>
